export default __webpack_public_path__ + "static/media/640_business02-es-mobile.785a9ccf.png";